// Format a per-app build number as a zero-padded, minimum-4-digit label
// ("0001"). Returns null for a missing/invalid build so callers can omit it.
// Mirrors the server's formatBuild() in server/routes/deploy.js.
export function formatBuild(n) {
  return Number.isInteger(n) && n > 0 ? String(n).padStart(4, '0') : null;
}

export default formatBuild;
